import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import FairProducts from "@/components/fair/FairProducts";
import FairOrderDialog from "@/components/fair/FairOrderDialog";
import FairOrderRow, { FAIR_STATUS } from "@/components/fair/FairOrderRow";
import FairCustomers from "@/components/fair/FairCustomers";
import FairSummary from "@/components/fair/FairSummary";
import { Link } from "react-router-dom";
import { Store, Plus, Printer } from "lucide-react";

export default function Fair() {
  const [products, setProducts] = useState([]);
  const [orders, setOrders] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [dialog, setDialog] = useState({ open: false, order: null });
  const [filter, setFilter] = useState("all");

  const load = async () => {
    const [p, o, c] = await Promise.all([api.get("/fair/products"), api.get("/fair/orders"), api.get("/fair/customers")]);
    setProducts(p.data); setOrders(o.data); setCustomers(c.data);
  };
  useEffect(() => { load(); }, []);

  const productById = (id) => products.find((p) => p.id === id);
  const koliOf = (st) => orders.filter((o) => st === "all" || o.status === st).reduce((a, o) => a + o.items.reduce((x, i) => x + i.koli, 0), 0);
  const shown = orders.filter((o) => filter === "all" || o.status === filter);

  return (
    <div className="p-5 lg:p-10 max-w-[1400px]" data-testid="fair-page">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6">
        <div>
          <p className="text-[11px] font-mono uppercase tracking-widest text-[#B45309] mb-2">Fuar</p>
          <h1 className="font-display text-3xl sm:text-4xl font-extrabold uppercase tracking-tight flex items-center gap-3">
            <Store className="w-7 h-7 text-[#D97706]" /> Fuar Siparişleri
          </h1>
          <p className="text-[#6B5B4A] mt-2 text-sm">Fuarda alınan siparişlerin takibi — stoka, kesime ve siparişlere işlenmez.</p>
        </div>
        <Button onClick={() => setDialog({ open: true, order: null })} data-testid="fair-order-new-btn"
          className="bg-[#D97706] hover:bg-[#B45309] text-white font-display uppercase tracking-wide h-11 px-5">
          <Plus className="w-4 h-4 mr-2" /> Yeni Fuar Siparişi
        </Button>
      </div>

      <Tabs defaultValue="orders">
        <TabsList className="bg-[#EFE6D6] mb-5">
          <TabsTrigger value="orders" data-testid="fair-tab-orders">Siparişler ({orders.length})</TabsTrigger>
          <TabsTrigger value="summary" data-testid="fair-tab-summary">Model Özeti</TabsTrigger>
          <TabsTrigger value="customers" data-testid="fair-tab-customers">Fuar Müşterileri ({customers.length})</TabsTrigger>
          <TabsTrigger value="products" data-testid="fair-tab-products">Fuar Kartları ({products.length})</TabsTrigger>
        </TabsList>
        <TabsContent value="orders">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-5">
            {[["all", "Tümü"], ...Object.entries(FAIR_STATUS).map(([k, v]) => [k, v.label])].map(([k, label]) => (
              <button key={k} onClick={() => setFilter(k)} data-testid={`fair-filter-${k}`}
                className={`text-left rounded-lg border p-4 transition-colors ${filter === k ? "border-[#D97706] bg-[#FFFBF4] ring-2 ring-[#D97706]/30" : "border-[#DCCFB8] bg-[#FFFBF4] hover:border-[#D97706]/50"}`}>
                <p className="text-[11px] font-mono uppercase tracking-widest text-[#6B5B4A]">{label}</p>
                <p className="font-display text-3xl font-extrabold mt-1" data-testid={`fair-sum-${k}`}>{koliOf(k)} <span className="text-sm font-mono font-normal">koli</span></p>
                <p className="text-xs text-[#8C7B68]">{orders.filter((o) => k === "all" || o.status === k).length} sipariş</p>
              </button>
            ))}
          </div>
          <div className="space-y-3" data-testid="fair-orders-list">
            {shown.length === 0 && <div className="rounded-lg border border-[#DCCFB8] bg-[#FFFBF4] p-10 text-center text-[#8C7B68]">Fuar siparişi yok.</div>}
            {shown.map((o) => <FairOrderRow key={o.id} o={o} productById={productById} onChanged={load} onEdit={(order) => setDialog({ open: true, order })} />)}
          </div>
        </TabsContent>
        <TabsContent value="summary">
          <div className="flex justify-end mb-3">
            <Link to="/fuar-ozet" target="_blank" data-testid="fair-summary-print-link"
              className="inline-flex items-center gap-2 h-10 px-4 rounded-md border border-[#DCCFB8] bg-[#FFFBF4] text-[#B45309] hover:bg-[#EFE6D6] text-sm font-medium">
              <Printer className="w-4 h-4" /> Özeti Yazdır
            </Link>
          </div>
          <FairSummary orders={orders} products={products} />
        </TabsContent>
        <TabsContent value="customers"><FairCustomers customers={customers} orders={orders} onChanged={load} /></TabsContent>
        <TabsContent value="products"><FairProducts products={products} onChanged={load} /></TabsContent>
      </Tabs>

      <FairOrderDialog open={dialog.open} order={dialog.order} products={products} customers={customers} onCustomersChanged={load} onSaved={load}
        onOpenChange={(v) => setDialog((d) => ({ ...d, open: v }))} />
    </div>
  );
}
